// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bdbc3909","703":"03f0dca2","787":"f2147654"}[chunkId] + ".chunk.js";
};